import { gql } from '@apollo/client'

export const GET_ATTRIBUTES_TREE = gql`
  query GET_ATTRIBUTES_TREE {
    findManyProductAttributeGroup(orderBy: { id: asc }) {
      id
      code
      product_attribute_group_profiles {
        id
        name
        description
        language
      }
      product_attributes(orderBy: { id: asc }) {
        id
        code
        product_attribute_profiles {
          id
          name
          description
          language
        }
        product_containers {
          id
        }
      }
    }
  }
`

export const GET_PRODUCT_ATTRIBUTES = gql`
  query GET_PRODUCT_ATTRIBUTES(
    $searchTerm: String
    $take: Int
    $skip: Int
    $orderBy: [ProductAttributeOrderByWithRelationInput!]
  ) {
    findManyProductAttribute(
      where: {
        product_attribute_profiles: {
          some: { name: { contains: $searchTerm, mode: insensitive } }
        }
      }
      take: $take
      skip: $skip
      orderBy: $orderBy
    ) {
      id
      code
      productAttributeGroupId
      product_attribute_group {
        id
        product_attribute_group_profiles {
          name
          language
        }
      }
      product_attribute_profiles {
        id
        name
        description
        language
      }
      product_containers {
        id
      }
      createdAt
      updatedAt
    }
    findManyProductAttributeCount(
      where: {
        product_attribute_profiles: {
          some: { name: { contains: $searchTerm, mode: insensitive } }
        }
      }
    )
  }
`

export const GET_PRODUCT_ATTRIBUTE = gql`
  query GetProductAttribute($id: Int!) {
    findUniqueProductAttribute(where: { id: $id }) {
      id
      code
      productAttributeGroupId
      product_attribute_group {
        id
        product_attribute_group_profiles {
          name
          language
        }
      }
      product_attribute_profiles {
        id
        name
        description
        language
      }
      product_containers {
        id
      }
    }
  }
`

export const GET_ATTRIBUTE_GROUPS_FOR_SELECT = gql`
  query GET_ATTRIBUTE_GROUPS_FOR_SELECT {
    findManyProductAttributeGroup {
      id
      product_attribute_group_profiles {
        name
        language
      }
    }
  }
`

export const CREATE_PRODUCT_ATTRIBUTE = gql`
  mutation CreateProductAttribute(
    $data: CreateProductAttributeWithProfilesInput!
  ) {
    createProductAttribute(data: $data) {
      id
      code
      product_attribute_profiles {
        name
        description
        language
      }
    }
  }
`

export const UPDATE_PRODUCT_ATTRIBUTE = gql`
  mutation UpdateProductAttribute(
    $where: ProductAttributeWhereUniqueInput!
    $data: UpdateProductAttributeWithProfilesInput!
  ) {
    updateProductAttribute(where: $where, data: $data) {
      id
      code
      productAttributeGroupId
      product_attribute_profiles {
        id
        language
        name
        description
      }
    }
  }
`

export const DELETE_PRODUCT_ATTRIBUTE = gql`
  mutation DeleteProductAttribute(
    $where: ProductAttributeWhereUniqueInput!
  ) {
    deleteOneProductAttribute(where: $where) {
      id
    }
  }
`

export const DELETE_MANY_PRODUCT_ATTRIBUTES = gql`
  mutation DELETE_PRODUCT_ATTRIBUTES($ids: [Int!]!) {
    deleteManyProductAttribute(where: { id: { in: $ids } }) {
      count
    }
  }
`
